// extracted by mini-css-extract-plugin
export default {"layout":"Intro_layout__gzZWj"};